import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import styles from "./RicercaSegnalazioniHIV.module.css";
import Table from "../../../components/table/Table";
import Button from "../../../components/button/Button";
import Spinner from "../../../components/spinner/Spinner";
import Utils from "../../../utils/Utils";
import Input from "../../../components/textbox/Input";
import Calendar from "../../../components/calendar/Calendar";
import toasterConfig from "../../../config/toasterConfig";
import history from "../../../utils/History";
import ToasterSingleton from "../../../singleton/ToasterSingleton";
import SegnalazioniHIVServices from "../../../services/SegnalazioniHIVServices";
import $ from "jquery";
import { labelConfig } from "../../../config/labelConfig";
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import Ruoli from "../../../utils/Ruoli.json";
import CodiceUnivoco from "../components/CodiceUnivoco/CodiceUnivoco";

class RicercaSegnalazioniHIV extends Component {
    state = {
        rows: [],
        noSectionActive: true,
        loading: false,
        sections: {
            progressivoRegistro: "",
            codicePaziente: "",
            dataSegnalazioneDa: "",
            dataSegnalazioneA: "",
        },
        erroreCodicePaziente: "",
        erroreProgressivoRegistro: "",
        showTable: false,
        page: 0,
        totalElements: 0,
        totalPages: 0,
        size: 10,
    };

    cols = [
        {
            key: "progressivoRegistro",
            name: "Tables.RicercaSegnalazioniHiv.id",
            sortDirection: "none",
            tipo: "link",
            path: "/formHIV",
            nomeParametro: "progressivoRegistro",
            state: { currentState: true },
        },
        {
            key: "codiceIndividualePaziente",
            name: "Tables.RicercaSegnalazioniHiv.paziente",
            sortDirection: "none",
        },
        {
            key: "codiceStruttura",
            name: "Tables.RicercaSegnalazioniHiv.ulssSegnalazione",
            sortDirection: "none",
        },
        {
            key: "dataSegnalazione",
            name: "Tables.RicercaSegnalazioniHiv.dataSegnalazione",
            sortDirection: "none",
            tipo: "data",
        },
    ];

    segnalazioni = [];

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.pulisciTutto = this.pulisciTutto.bind(this);
        this.executeSearch = this.executeSearch.bind(this);
        this.inserisciNuova = this.inserisciNuova.bind(this);
        this.changePageTable = this.changePageTable.bind(this);
        this.changePaginationTable = this.changePaginationTable.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.sonoCampiVergini = this.sonoCampiVergini.bind(this);
        this.isFormInvalido = this.isFormInvalido.bind(this);
        this.checkCodicePaziente = this.checkCodicePaziente.bind(this);
        this.getDataErrorMessage = this.getDataErrorMessage.bind(this);
        this.onBlurCodiceUnivoco = this.onBlurCodiceUnivoco.bind(this);
        this.onBlurProgressivoRegistro =
            this.onBlurProgressivoRegistro.bind(this);
        this.checkProgressivoRegistro =
            this.checkProgressivoRegistro.bind(this);
    }

    componentDidMount() {
        Utils.scrollToTheTop();
        ToasterSingleton.instance().pulisci();
        ToasterSingleton.instance().sottoscrizione(this);
        let object = {
            label: labelConfig.ricercaSegnalazioniHIV[0],
        };
        this.props.navLabel({ navLabel: object });
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione();
        this.props.navLabel({ navLabel: {} });
    }

    inserisciNuova() {
        history.push({
            pathname: "/formHIV",
            codicePaziente: this.state.sections.codicePaziente
                ? this.state.sections.codicePaziente
                : null,
        });
    }

    sonoCampiVergini() {
        let sections = this.state.sections;
        return (
            sections.progressivoRegistro === "" &&
            sections.codicePaziente === "" &&
            sections.dataSegnalazioneDa === "" &&
            sections.dataSegnalazioneA === ""
        );
    }

    // ritorna true se c'è un errore e il form non è inviabile
    isFormInvalido() {
        let sections = this.state.sections;

        // se c'è il progressivo registro ed è valido il form è valido
        if (
            sections.progressivoRegistro !== "" &&
            this.state.erroreProgressivoRegistro === ""
        )
            return false;

        const codicePazienteEsistenteValido =
            sections.codicePaziente !== "" &&
            this.state.erroreCodicePaziente === "";

        const campiDataVuoti =
            sections.dataSegnalazioneDa === "" &&
            sections.dataSegnalazioneA === "";

        const campiDataInseriti =
            sections.dataSegnalazioneDa !== "" &&
            sections.dataSegnalazioneA !== "";

        const campoDataDaValido =
            this.getDataErrorMessage("dataSegnalazioneDa").length === 0;

        const campoDataAValido = !Utils.controlloPerDataSegnalazioneAPerError(
            sections.dataSegnalazioneA,
            sections.dataSegnalazioneDa
        );

        const campiDataValidi =
            campiDataInseriti && campoDataDaValido && campoDataAValido;

        // se c'è il codice paziente ed è valido ed i campi data sono vuoti il form è valido
        if (codicePazienteEsistenteValido && campiDataVuoti) return false;

        // se i campi data sono presenti e validi ed il codice paziente è vuoto il form è valido
        if (campiDataValidi && sections.codicePaziente === "") return false;

        // se c'è il codice paziente valido ed i campi data non sono vuoti devono essere entrambi validi
        if (codicePazienteEsistenteValido && campiDataValidi) return false;

        // se nessuna delle condizioni sopra è verificata il form è invalido
        return true;
    }

    riceviValore(field, event) {
        let newSections = this.state.sections;

        if (field === "progressivoRegistro") {
            if (!isNaN(event.target.value)) {
                newSections.progressivoRegistro = event.target.value;
                this.checkProgressivoRegistro(event.target.value);
            }
        } else if (field === "codicePaziente") {
            newSections.codicePaziente = event.target.value;
            this.checkCodicePaziente(event.target.value);
        } else if (field.currentTarget.id === "dataSegnalazioneDa") {
            newSections.dataSegnalazioneDa = field.target.value;
        } else if (field.currentTarget.id === "dataSegnalazioneA") {
            newSections.dataSegnalazioneA = field.target.value;
        }

        this.setState({ sections: newSections });
    }

    pulisciTutto() {
        this.setState({
            sections: {
                progressivoRegistro: "",
                codicePaziente: "",
                dataSegnalazioneDa: "",
                dataSegnalazioneA: "",
            },
            showTable: false,
            page: 0,
        });
    }

    executeSearch() {
        let that = this;
        setTimeout(function () {
            let params = that.buildParams();
            params.page = 0;
            that.sendRequest(params, true);
        }, 50);
    }

    sendRequest(params, notPagination) {
        if (notPagination)
            this.setState({ loading: true, disabledTableButtons: true });
        else this.setState({ loading: true });

        SegnalazioniHIVServices.getSegnalazioniHIV(params)
            .then((data) => {
                if (!data.data.content || data.data.content.length === 0) {
                    this.aggiungiToaster();
                }
                let res = SegnalazioniHIVServices.mapGetSegnalazioniHIV(data);
                let newState = {
                    rows: Utils.idSegnalazioneUlss(res),
                    totalElements: data.data.totalElements,
                    showTable: true,
                    totalPages: data.data.totalPages,
                    loading: false,
                };

                if (params.size && params.size !== this.state.size) {
                    newState["size"] = params.size;
                }
                if (
                    (params.page || params.page === 0) &&
                    params.page !== this.state.page
                ) {
                    newState["page"] = params.page;
                }

                this.setState(newState);
            })
            .catch((reason) => {
                let state = {
                    rows: [],
                    totalElements: 0,
                    showTable: true,
                    loading: false,
                    page: 0,
                };
                if (params.size && params.size !== this.state.size) {
                    state["size"] = params.size;
                }
                if (
                    (params.page || params.page === 0) &&
                    params.page !== this.state.page
                ) {
                    state["page"] = params.page;
                }
                console.log("[Error] GetSegnalazioniHIV in errore:", reason);
                this.setState(state);
            });
    }

    aggiungiToaster() {
        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.informational,
            text: ["Toasters.Messages.no_result"],
            timestamp: Date.now(),
        });
    }

    buildParams(sort, direction, page, size) {
        let sezioni = this.state.sections;

        let params = {};
        if (sezioni.progressivoRegistro) {
            if (sezioni.progressivoRegistro.length === 15) {
                params["progressivoRegistro"] =
                    +sezioni.progressivoRegistro.substring(6);
                params["codiceStruttura"] =
                    sezioni.progressivoRegistro.substring(0, 6);
            } else params["progressivoRegistro"] = +sezioni.progressivoRegistro;
        }

        if (sezioni.codicePaziente) {
            params["codiceIndividualePaziente"] = encodeURIComponent(
                sezioni.codicePaziente
            );
        }

        if (sezioni.dataSegnalazioneDa) {
            params["dataSegnalazioneDa"] = Utils.transformDateForBackend(
                sezioni.dataSegnalazioneDa.toUpperCase()
            );
        }
        if (sezioni.dataSegnalazioneA) {
            params["dataSegnalazioneA"] = Utils.transformDateForBackend(
                sezioni.dataSegnalazioneA.toUpperCase()
            );
        }
        params["ulss"] =
            SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_HIV.descrizione ||
            SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Sisp_HIV.descrizione
                ? SessioneUtente.getInstance().ulss
                : null;

        params.home = false;
        params.page = page;
        params.order = direction;
        params.sort = sort;
        params.size = size;

        return Utils.removeEmptyValueFromObject(params);
    }

    changePageTable(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);
        if (size != null) {
            if (size !== this.state.size) {
                params.size = this.state.size;
            } else {
                params.size = size;
            }
        }
        this.sendRequest(params, false);
    }

    changePaginationTable(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);
        if (size != null) params.size = size;
        this.sendRequest(params, false);
    }

    checkCodicePaziente(codicePaziente) {
        this.setState({
            erroreCodicePaziente:
                Utils.getMessaggioErroreCodiceUnivocoPazienteHIV(
                    codicePaziente
                ),
        });
    }

    checkProgressivoRegistro(progressivoRegistro) {
        let errore = "";
        if (progressivoRegistro === "") {
            $(document).ready(function () {
                $("#dataSegnalazioneDa").datepicker("enable");
                $("#dataSegnalazioneA").datepicker("enable");
            });
        } else {
            $(document).ready(function () {
                $("#dataSegnalazioneDa").datepicker("disable");
                $("#dataSegnalazioneA").datepicker("disable");
            });
            if (progressivoRegistro.length > 15)
                errore = "Progressivo di registro troppo lungo";
        }
        this.setState({ erroreProgressivoRegistro: errore });
    }

    getDataErrorMessage = (key) => {
        let value = this.state.sections[key];

        if (!value) return "";

        if (key === "dataSegnalazioneDa") {
            if (
                Utils.isDateInValid(
                    Utils.transformDateForBackend(this.state.sections[key]),
                    "-"
                ) &&
                value !== ""
            )
                return "Data non valida";

            value = value.split("/").reverse().join("/");

            if (Utils.isDateInTheFuture(value))
                return "'Data segnalazione da' futura non valida";
        }
        return "";
    };

    onBlurCodiceUnivoco = () => {
        // converti il codice univoco in uppercase
        this.setState((prevState) => ({
            sections: {
                ...prevState.sections,
                codicePaziente: prevState.sections.codicePaziente.toUpperCase(),
            },
        }));

        // se c'è già un errore evidenziato non continuare
        if (this.state.erroreCodicePaziente) return;

        const valoreCodiceAttuale = this.state.sections.codicePaziente;
        // check lunghezza del codice, se non è 11 chars indica l'errore
        if (valoreCodiceAttuale.length > 0 && valoreCodiceAttuale.length < 11) {
            this.setState((prevState) => ({
                erroreCodicePaziente: `Il codice deve essere di 11 caratteri, ne manca${
                    valoreCodiceAttuale.length === 10 ? "" : "no"
                } ${11 - valoreCodiceAttuale.length}`,
                sections: {
                    ...prevState.sections,
                    codicePaziente: valoreCodiceAttuale + " ",
                },
            }));
            // timeout che ripristina il valore originale di valoreCodice
            setTimeout(() => {
                this.setState((prevState) => ({
                    sections: {
                        ...prevState.sections,
                        codicePaziente: valoreCodiceAttuale,
                    },
                }));
            }, 200);
        }
    };

    onBlurProgressivoRegistro = () => {
        const progressivoRegistroAttuale =
            this.state.sections.progressivoRegistro;
        // check formato del progressivoRegistro
        if (
            progressivoRegistroAttuale.length > 9 &&
            progressivoRegistroAttuale.length < 15
        ) {
            this.setState((prevState) => ({
                erroreProgressivoRegistro:
                    "Formato del progressivo di registro errato",
                sections: {
                    ...prevState.sections,
                    progressivoRegistro: progressivoRegistroAttuale + " ",
                },
            }));
            // timeout che ripristina il valore originale di progressivoRegistro
            setTimeout(() => {
                this.setState((prevState) => ({
                    sections: {
                        ...prevState.sections,
                        progressivoRegistro: progressivoRegistroAttuale,
                    },
                }));
            }, 200);
        }
    };

    render() {
        const { t } = this.props;
        const bluButton = "btnBlu";
        const whiteButton = "btnWhite";

        const spinnerDiv = (
            <div>
                <Spinner />
            </div>
        );
        const firstSection = (
            <div>
                <div className={"row"} style={{ marginBottom: "1.5rem" }}>
                    <div className={"col-12"}>
                        <p className={styles.labelHeader.concat(" mb-1")}>
                            {"Progressivo di registro"}
                        </p>
                        <Input
                            id={"progressivoRegistro"}
                            field={"progressivoRegistro"}
                            onChange={this.riceviValore}
                            onBlur={this.onBlurProgressivoRegistro}
                            disabled={
                                this.state.sections.codicePaziente !== "" ||
                                this.state.sections.dataSegnalazioneDa !== "" ||
                                this.state.sections.dataSegnalazioneA !== ""
                            }
                            value={this.state.sections.progressivoRegistro}
                            placeholder={"Progressivo di Registro"}
                            errorMessage={this.state.erroreProgressivoRegistro}
                            onValidate={
                                this.state.erroreProgressivoRegistro !== ""
                                    ? 1
                                    : 2
                            }
                        />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <p
                            className={styles.labelHeader}
                            style={{ textAlign: "center" }}
                        >
                            Oppure
                        </p>
                    </div>
                </div>
                <div className={"row"} style={{ marginBottom: "1rem" }}>
                    <div className={"col-12 justify-content-between"}>
                        <p className={styles.labelHeader}>Codice paziente</p>
                        <p className={styles.labelSpiegazione}>
                            Inserire prima e terza lettera del cognome, prima e
                            terza lettera del nome, le cifre della data nascita
                            (gg/mm/aa) e la lettera del sesso
                        </p>

                        <CodiceUnivoco
                            id={"codicePaziente"}
                            field={"codicePaziente"}
                            onChange={this.riceviValore}
                            onBlur={this.onBlurCodiceUnivoco}
                            disabled={
                                this.state.sections.progressivoRegistro !== ""
                            }
                            placeholder={"Codice Individuale Paziente"}
                            value={this.state.sections.codicePaziente}
                            errorMessage={this.state.erroreCodicePaziente}
                            onValidate={
                                this.state.erroreCodicePaziente !== "" ? 1 : 2
                            }
                        />
                    </div>
                </div>
                <p className={styles.labelHeader.concat(" mb-1")}>
                    {"Data segnalazione"}
                </p>
                <div className={"row"} style={{ marginBottom: "1rem" }}>
                    <div className={"col-lg-6 col-12 mb-lg-0 mb-1"}>
                        <div className={"row"}>
                            <div
                                className={"col-1"}
                                style={{ textAlign: "end", fontSize: "95%" }}
                            >
                                <span>Da:</span>
                            </div>
                            <div className={"col-11"}>
                                <Calendar
                                    id={"dataSegnalazioneDa"}
                                    value={
                                        this.state.sections.dataSegnalazioneDa
                                    }
                                    onChange={this.riceviValore}
                                    field={"dataSegnalazioneDa"}
                                    disabled={
                                        this.state.sections
                                            .progressivoRegistro !== ""
                                    }
                                    errorMessage={this.getDataErrorMessage(
                                        "dataSegnalazioneDa"
                                    )}
                                    error={
                                        !!this.getDataErrorMessage(
                                            "dataSegnalazioneDa"
                                        )
                                    }
                                />
                                <span
                                    className={styles.labelSpiegazione}
                                    style={{ color: "red" }}
                                >
                                    {this.state.sections.dataSegnalazioneA !==
                                        "" &&
                                    this.state.sections.dataSegnalazioneDa ===
                                        ""
                                        ? "Campo obbligatorio"
                                        : ""}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className={"col-lg-6 col-12"}>
                        <div className={"row"}>
                            <div
                                className={"col-1"}
                                style={{ textAlign: "end", fontSize: "95%" }}
                            >
                                <span>A:</span>
                            </div>
                            <div className={"col-11"}>
                                <Calendar
                                    id={"dataSegnalazioneA"}
                                    value={
                                        this.state.sections.dataSegnalazioneA
                                    }
                                    onChange={this.riceviValore}
                                    disabled={
                                        this.state.sections
                                            .progressivoRegistro !== ""
                                    }
                                    field={"dataSegnalazioneA"}
                                    errorMessage={Utils.controlloPerDataSegnalazioneAPerMessageError(
                                        this.state.sections.dataSegnalazioneA,
                                        this.state.sections.dataSegnalazioneDa
                                    )}
                                    error={Utils.controlloPerDataSegnalazioneAPerError(
                                        this.state.sections.dataSegnalazioneA,
                                        this.state.sections.dataSegnalazioneDa
                                    )}
                                />
                                <span
                                    className={styles.labelSpiegazione}
                                    style={{ color: "red" }}
                                >
                                    {this.state.sections.dataSegnalazioneDa !==
                                        "" &&
                                    this.state.sections.dataSegnalazioneA === ""
                                        ? "Campo obbligatorio"
                                        : ""}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const buttonDiv = (
            <div className={"row"}>
                <Button
                    id={"idButtonClean"}
                    text={t("Buttons.clean")}
                    disabled={this.sonoCampiVergini()}
                    onClick={this.pulisciTutto}
                    className={[whiteButton, "col-8 col-lg-3 mx-auto"].join(
                        " "
                    )}
                    style={{ height: "3rem", marginTop: "1rem" }}
                />
                <Button
                    id={"idButtonSearch"}
                    text={t("Buttons.search")}
                    disabled={this.isFormInvalido()}
                    onClick={this.executeSearch}
                    className={[bluButton, "col-8 col-lg-3 mx-auto"].join(" ")}
                    style={{ height: "3rem", marginTop: "1rem" }}
                />
                {Utils.checkFunzionalitaByRuolo("idButtonInsertNew") ? (
                    <Button
                        id={"idButtonInsertNew"}
                        text={t("Buttons.insert_new")}
                        onClick={this.inserisciNuova}
                        className={[whiteButton, "col-8 col-lg-3 mx-auto"].join(
                            " "
                        )}
                        style={{ height: "3rem", marginTop: "1rem" }}
                    />
                ) : null}
            </div>
        );

        const tableDiv = (
            <div id="contenitoreTabella" className={styles.contenitoreTabella}>
                <Table
                    cols={this.cols}
                    rows={this.state.rows}
                    title={t("Tables.RicercaSegnalazioniHiv.tableTitle")}
                    empty={this.state.rows && this.state.rows.length === 0}
                    emptyMsg={t("Tables.RicercaSegnalazioniHiv.noSegnalazioni")}
                    lengthEditable={true}
                    totalElements={this.state.totalElements}
                    bigTable={true}
                    totalPages={this.state.totalPages}
                    page={this.state.page}
                    changePage={this.changePageTable}
                    changePagination={this.changePaginationTable}
                    tableLenght={this.state.size}
                />
            </div>
        );

        return (
            <div className={styles.contenitore}>
                {ToasterSingleton.instance().renderToaster()}
                {this.state.loading ? <div>{spinnerDiv}</div> : <div />}
                {firstSection}
                {buttonDiv}
                {this.state.showTable ? <div>{tableDiv}</div> : <div />}
            </div>
        );
    }
}

export default withTranslation("common")(RicercaSegnalazioniHIV);
